export enum BudgetStatus {
Draft,
Approved,
Rejected,
Submited,
Canceled,
}
